'use client';

import { useState } from 'react';

export const useTooltipOpen = () => {
  const [open, setOpen] = useState(false);
  return {
    open,
    onOpenChange: setOpen,
    trigger: () => {
      setOpen(true);
    },
  };
};
